import React, { useState } from 'react';
import config from '../config';

const MessageInput = ({ onSendMessage, placeholder }) => {
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [sendError, setSendError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim() || isSending) return;
    setIsSending(true);
    setSendError('');
    try {
      await onSendMessage(message.trim());
      setMessage('');
    } catch (error) {
      setSendError(error.message || 'Message not sent. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="message-input">
      <form onSubmit={handleSubmit} className="message-input-form" aria-label="Compose message">
        <label htmlFor="message-draft" className="sr-only">Message</label>
        <input id="message-draft" type="text" value={message}
          onChange={(e) => e.target.value.length <= config.maxMessageLength && setMessage(e.target.value)}
          placeholder={placeholder || 'Type a message…'} disabled={isSending}
          maxLength={config.maxMessageLength} autoComplete="off" aria-describedby="message-count" />
        <button type="submit" className="send-button" disabled={!message.trim() || isSending}
          aria-label={isSending ? 'Sending message' : 'Send message'} aria-busy={isSending}>
          <span aria-hidden="true">{isSending ? '…' : '↑'}</span>
        </button>
      </form>
      <div className="character-count" id="message-count">{message.length}/{config.maxMessageLength}</div>
      {sendError && <div className="error-message" role="alert">{sendError}</div>}
    </div>
  );
};

export default MessageInput;
